import Checkbox from '@oncolens/oncolens-ui/lib/components/FormControls/Checkbox';
import Listbox from '@oncolens/oncolens-ui/lib/components/FormControls/Listbox';
import TextAreaInput from '@oncolens/oncolens-ui/lib/components/FormControls/TextAreaInput';
import React from 'react';
import { useGetOrganizationExperts } from '../../api/getOrganizationExperts';
import RequestFormField from './RequestFormField';
import RequestSection from './RequestSection';

interface SubmitToSectionProps {
	organizationId: string | undefined;
}

const SubmitToSection = ({ organizationId }: SubmitToSectionProps) => {
  const { data } = useGetOrganizationExperts(organizationId || '');
  const specialists = (data || []).map((orgExpert) => ({
    label: !orgExpert.firstName ? orgExpert.email : `${orgExpert.firstName} ${orgExpert.lastName}`,
    value: orgExpert.id
  }));

  return (
    <RequestSection title="1. Enter reason for request">
      <div className="grid items-center gap-3 sm:grid-cols-3">
        <div>
          <RequestFormField name="submitTo.preferredPhysicianId">
            {({ value, onChange, errorMessage }) => (
              <Listbox
                label="Preferred physician (if known):"
                data={specialists}
                error={errorMessage}
                selected={value}
                setSelected={onChange}
              />
            )}
          </RequestFormField>
        </div>
        <div className="self-end">
          <RequestFormField name="submitTo.highPriority">
            {({ onChange, value }) => (
              <Checkbox
                id="highPriority"
                htmlName="highPriority"
                label="High Priority"
                value={value}
                inputProps={{ onChange: onChange, checked: value }}
              />
            )}
          </RequestFormField>
        </div>
        <RequestFormField name="submitTo.reasonsForRequest">
          {({ onChange, value, errorMessage }) => (
            <TextAreaInput
              id="reasonsForRequest"
              label="Reason for request"
              htmlName="reasonsForRequest"
              required={true}
              value={value}
              onChange={onChange}
              error={errorMessage}
              wrapperProps={{ className: 'sm:col-span-3' }}
            />
          )}
        </RequestFormField>
      </div>
    </RequestSection>
  );
};

export { SubmitToSection as default };
